<template>
	<div class="container-fluid p-0 m-0 ">
		<MainDarkBarTop ref="promobarf" v-if="main.isavailable" class="topbar" />
		<!-- <MainDarkCustomBarTop ref="promocustombarf" v-if="main.isavailable" class="topbar" /> -->
		<MainDarkLandingBarTop ref="landingcustombarf" xv-if="!main.isavailable" class="topbar" />
		<div class="navtop" id="homepageheader" ref="homepageheaderf" :class="[ main.isavailable? 'homepageheader' : 'nhpage' ]">
			<div class="d-lg-flex col-12 align-items-lg-center mx-auto pt-2 align-items-md-top robotofonts maintop" ref="fixedbarf" style="min-height:66px;">
				<div class="col-11 d-lg-flex align-items-center mx-auto justify-content-center position-relative">
					<TopNavBar>
						<template v-slot:search>
							<div v-if="!main.isavailable" class="ms-auto d-flex align-items-left justify-content-left col-2 col-md-2 mx-4 searchbox">
								<SearchBox @doSearch="doSearch" disablekeyup nopill noborder bottomborder />
							</div>
						</template>
					</TopNavBar>
					<div v-if="filter.isavailable" class="ms-3 text-nowrap px-4 d-none d-lg-block">
						<button type="button" class="btn btn-light rounded-pill border px-5" @click="filter.isopen=!filter.isopen"><i class="bi bi-sliders"></i> Filter</button>
					</div>
					<div class="navright d-flex ms-auto align-items-lg-center align-items-md-top mt-lg-0 mt-md-3">
						<span v-if="!loggedin" class="ms-auto me-2"><a href="/login"><button type="button" :class="{ 'bg-transparent border-0' : main.isavailable }" class="fw-semibold btn btn-sm btn-light d-none sign-in-btn d-lg-block text-nowrap">{{ $t('menu.signin', 'Log In') }}</button></a></span>
						<LanguageSelector class="d-none d-lg-block" colorclass="tt-text" top />
						<TopNavBarUser v-if="loggedin" />
					</div>
				</div>
			</div>
			<div class="hphtop" v-if="main.isavailable" >
				<MainHeader />
				<MainSubHeader />
			</div>
		</div>
		<router-view class="view sidemain h-100" name="sidemain"></router-view>
		<FooterDark v-if="!main.hidefooter" />
	</div>
</template>
<script lang="ts" setup>
import { onBeforeMount, onMounted, ref } from 'vue';
import SearchBox from '@/components/elements/SearchBox.vue';
// import ShoppingCart from '@/components/elements/ShoppingCart.vue';
import LanguageSelector from '@/components/elements/LanguageSelector.vue';
import TopNavBar from '@/components/TopNavBar.vue';
import TopNavBarUser from '@/components/TopNavbarUser.vue';
import MainDarkBarTop from '@/components/mainpage/MainDarkBarTop.vue';
// import MainDarkCustomBarTop from '@/components/mainpage/MainDarkCustomBarTop.vue';
import MainDarkLandingBarTop from '@/components/mainpage/MainDarkLandingBarTop.vue';
import MainHeader from '@/components/mainpage/MainHeader.vue';
import MainSubHeader from '@/components/mainpage/MainSubHeader.vue';
import { getCookie } from "@/common/common.js";
import { userMainStore } from '@/store/userMainStore';
import { userFilterStore } from '@/store/userFilterStore';
import FooterDark from '@/components/layout/FooterDark.vue';

const main = userMainStore();
const filter = userFilterStore();

let loggedin = false;
let fixedbarf = ref(null);
let homepageheaderf = ref(null);
let promobarf = ref(null);
// let promocustombarf = ref(null);
let landingcustombarf = ref(null);
let vh = ref(0);

defineProps({
	msg: String
})

onBeforeMount(
	async () => {
		if (getCookie("uid")) {
			loggedin = true;
		}
	});


onMounted(
	async () => {
		fixedMenu();
		mobileOnly();
	});

const mobileOnly = () => {
	if (!window.matchMedia("(max-width: 992px)").matches) return;
	let elements = document.getElementsByClassName("tt-dropdown-item");
	let navbar = document.querySelector(".navbar-collapse.collapse");
	let navMobileFunction = function() {
		navbar.classList.remove("show");
		document.querySelector("button.navbar-toggler").setAttribute("aria-expanded", "false")
	};
	for (let i = 0; i < elements.length; i++) {
		elements[i].addEventListener('click', navMobileFunction, false);
	}
}

const fixedMenu = () => {
	vh.value = window.innerHeight / 2;
	let offset = homepageheaderf?.value.offsetHeight;
	document.addEventListener('scroll', function() {
		setTimeout(function() {
			var timeoutId = null;
			if (timeoutId) clearTimeout(timeoutId);
			timeoutId = setTimeout(fixedBar, 30);
		});
	});

	function fixedBar() {
		if (window.scrollY > vh.value + offset) {
			fixedbarf.value?.classList.remove("stickyout");
			fixedbarf.value?.classList.add("sticky");
		} else if (window.scrollY < 10 /*offset + vh.value*/ ) {
			fixedbarf.value?.classList.remove("sticky");
			fixedbarf.value?.classList.add("stickyout");

		}
	}
}

const doSearch = (s) => {
	document.location = '/d/search/' + s;
}
</script>
<style scoped lang="scss">
.maintop.sticky {
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	z-index: 1030;
	opacity: 1;
	animation-name: fadeInOpacity;
	animation-iteration-count: 1;
	animation-timing-function: ease-in;
	animation-duration: 1s;
	background-color: rgba(255, 255, 255, .99);
	box-shadow: 0 .1rem .1rem rgba(0, 0, 0, .045) !important;
	transition: all 1s linear;
}

.maintop.sticky .searchbox {
	opacity: .3 !important;
	transition: .5s;
}

.maintop.sticky .searchbox:focus-within {
	opacity: 1 !important
}

.maintop.stickyout {
	transition: top 1s linear;
	animation-name: fadeOutClick;
	animation-iteration-count: 1;
	animation-timing-function: ease-in;
	xanimation-duration: .3s;
}

.sticky .navbar {
	--x-nav-link-color: #000;
}

.sticky .lang-btn {
	--bs-white-rgb: 0, 0, 0 !important;
}

@keyframes fadeOutClick {
	0% {
		transform: translateY(-90%);
	}

	100% {
		transform: translateY(0px);
	}
}

@keyframes fadeInOpacity {
	0% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}

/*
.homepageheader {
	background:
		linear-gradient(to bottom, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.01)),
		url('@/assets/img/homebg/init.png') no-repeat top center;
	background-size: cover;
	min-height: 100vh;
}
*/

.hphtop {
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
	align-items: center;
	gap: 120px;
	background: var(--Background-White, #FFFFFE);
	padding: 120px 0;
}

.subhph {
	display: flex;
	flex-direction: column;
	gap: 32px;
	background-size: cover;
	min-height: 100vh;
	border-radius: 12px;
	background: linear-gradient(0deg, #FFF 27.38%, var(--Green-100, #75AE3D) 100%);
	box-shadow: -35px 0px 35px 0px rgba(255, 255, 255, 0.25) inset, 35px 0px 35px 0px rgba(255, 255, 255, 0.25) inset;
}

.nhpage {
	background: none !important;
}


.maintop:not(.sticky) {
	border-bottom: 1px solid #1616161A;
}

.homepageheader .maintop {
	border-bottom: 1px solid #FFFFFE33;
}

.topbbar {
	position: relative;
	top: -66px;
}

#app .btn:hover {
	color: var(--bs-btn-hover-color);
	background-color: var(--x-bs-btn-hover-bg);
	border-color: var(--x-bs-btn-hover-border-color);
}


@media (max-width: 1450px) {
	.searchbox {
		display: none !important;
	}
}
</style>